import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { org, loading, wallet } from '../types';
import scogo_apis from '../scogo_apis';
import { actualValueForDropdown } from '../utils/common';
import { OrgTypes } from '../utils/common';

export function* getOrgList(action) {
    const { limit, page, query, dropdown = false, type, vendors_from, get_verification_data, source, is_rma = false } = action.payload;
    const payload = {
        limit,
        page
    };
    if (type) payload.type = type
    if (query) payload.q = query;
    if (vendors_from) payload.vendors_from = vendors_from;
    if (get_verification_data) payload.get_verification_data = get_verification_data;
    if (is_rma) payload.is_rma = is_rma;

    try {
        if (source === 'po' && dropdown) {
            yield put({ type: loading.GET_PO_ORG_LIST_LOADING, payload: true });
        } else {
            yield put({ type: loading.GET_ORG_LIST_LOADING, payload: true });
        }
        const response = yield call(scogo_apis.org.getOrgList, {}, {}, payload);
        if (response.status === 200) {
            if (dropdown) {
                let dropdownData = response.data.data.map((elem) => ({ value: elem.id, label: elem.name, id: elem.id, verifications: elem.verifications, address: elem.address }));

                if (source === 'po') {
                    yield put({ type: org.GET_PO_ORG_DROPDOWN_LIST_DATA_SUCCESS, payload: { data: dropdownData, query } });
                } else if (type === OrgTypes.VENDOR) {
                    yield put({ type: org.GET_VENDOR_ORG_DROPDOWN_LIST_DATA_SUCCESS, payload: { data: dropdownData, query } });
                } else {
                    yield put({ type: org.GET_ORG_DROPDOWN_LIST_DATA_SUCCESS, payload: { data: dropdownData, query } });
                }
            } else {
                yield put({ type: org.GET_ORG_LIST_SUCCESS, payload: { data: response.data.data, dropdown: false, page } });
            }



        } else {
            yield put({ type: org.GET_ORG_LIST_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: org.GET_ORG_LIST_FAILURE, payload: error });
    }

    if (source === 'po' && dropdown) {
        yield put({ type: loading.GET_PO_ORG_LIST_LOADING, payload: false });
    } else {
        yield put({ type: loading.GET_ORG_LIST_LOADING, payload: false });
    }
}


export function* getOrgDetails(action) {
    const { orgId, limit, page, query, callWalletDetails = false } = action.payload;
    const payload = {
        limit,
        page
    };

    if (query) payload.q = query;
    try {
        yield put({ type: loading.GET_ORG_DETAIL_LOADING, payload: true });
        const response = yield call(scogo_apis.org.getOrgDetail, {}, { orgId }, payload);
        if (response.status === 200) {
            if (callWalletDetails && response?.data?.data?.user?.id) {
                yield put({ type: wallet.GET_USER_WALLET_BY_ID_REQUEST, payload: { userId: response.data.data.user.id } })
            }
            yield put({ type: org.GET_ORG_DETAIL_SUCCESS, payload: response.data.data });
        } else {
            yield put({ type: org.GET_ORG_DETAIL_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: org.GET_ORG_DETAIL_FAILURE, payload: error });
    }
    yield put({ type: loading.GET_ORG_DETAIL_LOADING, payload: false });
}

export function* getOrgContacts(action) {
    const { orgId, limit, page, query, dropdown } = action.payload;
    const payload = {
        limit,
        page,
    };

    if (query) payload.q = query;

    try {
        yield put({ type: loading.GET_ORG_CONTACTS_LOADING, payload: true });
        const response = yield call(scogo_apis.org.getContacts, {}, { orgId }, payload);
        if (response.status === 200) {
            let data = response.data.data;
            if (dropdown) {
                data = data.map((elem) => ({ value: elem.id, label: `${elem.name || ''} - (${elem.mobile || ''})`, id: elem.id, email: elem.email, mobile: elem.mobile, name: elem.name }));
                yield put({ type: org.GET_ORG_CONTACTS_DROPDOWN_SUCCESS, payload: { data, page, dropdown, orgId, query } });
            } else {
                yield put({ type: org.GET_ORG_CONTACTS_SUCCESS, payload: { data, page, dropdown, orgId } });
            }
        } else {
            yield put({ type: org.GET_ORG_CONTACTS_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: org.GET_ORG_CONTACTS_FAILURE, payload: error });
    }
    yield put({ type: loading.GET_ORG_CONTACTS_LOADING, payload: false });
}

export function* getOrgEndUsers(action) {
    const { orgId, limit, page, query, dropdown } = action.payload;
    const payload = {
        limit,
        page,
        type: 'END_USER'
    };

    if (query) payload.q = query;
    try {
        yield put({ type: loading.GET_ORG_END_USERS_LOADING, payload: true });
        const response = yield call(scogo_apis.org.getEntities, {}, { orgId }, payload);
        if (response.status === 200) {
            let data = response.data.data.map((elem) => ({ value: elem.id, label: elem.name, id: elem.id }));
            if (dropdown) {
                yield put({ type: org.GET_ORG_END_USERS_DROPDOWN_SUCCESS, payload: { data, orgId, query } });
            } else {
                yield put({ type: org.GET_ORG_END_USERS_SUCCESS, payload: { data, orgId } });
            }
        } else {
            yield put({ type: org.GET_ORG_END_USERS_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: org.GET_ORG_END_USERS_FAILURE, payload: error });
    }
    yield put({ type: loading.GET_ORG_END_USERS_LOADING, payload: false });
};

export function* getOrgBranches(action) {
    const { orgId, limit, page, query, dropdown } = action.payload;
    const payload = {
        limit,
        page,
        type: 'BRANCH'
    };

    if (query) payload.q = query;
    try {
        yield put({ type: loading.GET_ORG_BRANCHES_LOADING, payload: true });
        const response = yield call(scogo_apis.org.getEntities, {}, { orgId }, payload);
        if (response.status === 200) {
            if (dropdown) {
                let data = response.data.data.map((elem) => ({ value: elem.id, label: elem.name, id: elem.id }));
                yield put({ type: org.GET_ORG_BRANCHES_DROPDOWN_SUCCESS, payload: { data, orgId, query } });
            } else {
                yield put({ type: org.GET_ORG_BRANCHES_SUCCESS, payload: { data: response.data.data, orgId, page, limit } });
            }
        } else {
            yield put({ type: org.GET_ORG_BRANCHES_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: org.GET_ORG_BRANCHES_FAILURE, payload: error });
    }
    yield put({ type: loading.GET_ORG_BRANCHES_LOADING, payload: false });
}

export function* postEntities(action) {
    const { orgId, payload } = action.payload;

    try {
        const response = yield call(scogo_apis.org.postEntities, {}, { orgId }, payload);


    } catch (err) {

    }
}
export default function* orgSaga() {
    yield takeEvery(org.GET_ORG_LIST_REQUEST, getOrgList);
    yield takeLatest(org.GET_ORG_DETAIL_REQUEST, getOrgDetails);
    yield takeLatest(org.GET_ORG_CONTACTS_REQUEST, getOrgContacts);
    yield takeLatest(org.GET_ORG_END_USERS_REQUEST, getOrgEndUsers);
    yield takeLatest(org.GET_ORG_BRANCHES_REQUEST, getOrgBranches);
    yield takeLatest(org.POST_ENTITIES_REQUEST, postEntities);
}
